export default __webpack_public_path__ + "static/media/img_20.51abc1e7.jpg";